<template>
  <section>
    <Title v-if="title.MonetaryCompensation" :title-name="pageTitle" :title-link="title.MonetaryCompensation.titleLink" />
    <div class="monetary-wrapper">
      <div id="monetary-title">
        <ItemOfVouchers
          icon="monetary-compensation"
          color="#bbe35d"
          :label="lang['monetary_compensation_new'].SFS_LANG_ROW_10 || 'Monetary compensation'"
          border
        />
      </div>
      <div v-if="lang && lang.monetary_compensation_new" id="monetatry-compensation-block">
        <div class="container pt-4">
          <MonetaryCompensationMethods
            v-if="step == 0"
            :info-cash-order="infoCashOrder"
            :service="MonetaryService"
            :info-pax-monetary-detail="InfoPaxMonetaryDetail"
            :secret="secret"
            :monetary-id="monetaryId"
            @updateInfoCompensation="updateInfoCompensation"
          />
          <MonetaryCompensationConfirm
            v-if="step == 1"
            :info-cash-order="infoCashOrder"
            :service="MonetaryService"
            :monetary-id="monetaryId"
            @processConfirm="processConfirm"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/MonetaryCompensation.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import MonetaryCompensationMethods from './MonetaryCompensationMethods'
import MonetaryCompensationConfirm from './MonetaryCompensationConfirm'
export default {
  name: 'MonetaryCompensationService',
  components: {
    Title,
    ItemOfVouchers,
    MonetaryCompensationMethods,
    MonetaryCompensationConfirm
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    monetaryId: {
      type: [String, Number],
      default: ''
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      step: 0,
      InfoPaxMonetaryDetail: {},
      infoCashOrder: {
        currency: null,
        opent_amount: null
      }
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      InfoPaxMonetary: 'MonetaryCompensation/InfoPaxMonetary',
      MonetaryService: 'Home/monetaryService'
    }),
    pageTitle() {
      const { lang } = this
      return lang && lang.hotel_mobile_new && this.lang.hotel_mobile_new.SFS_LANG_ROW_28
        ? lang.hotel_mobile_new.SFS_LANG_ROW_28
        : 'Monetary compensation'
    }
  },
  watch: {
    Services: {
      handler() {
        this.CheckMonetaryOrder()
      },
      deep: true
    },
    MonetaryService: function (el) {
      if (el && el.list_monetary) {
        this.CheckMonetaryOrder()
      }
    },
    pax: function (el) {
      if (el && el.id) {
        let cur_pax_id = el.curPaxID ? el.curPaxID : el.id
        this.$store.dispatch('Home/getServices', cur_pax_id)
      }
    }
  },
  beforeMount() {
    if (!this.MonetaryService || (this.MonetaryService && !this.MonetaryService.list_monetary && this.pax)) {
      let cur_pax_id = this.pax.curPaxID ? this.pax.curPaxID : this.pax.id
      this.$store.dispatch('Home/getServices', cur_pax_id)
    } else {
      this.CheckMonetaryOrder()
    }
  },
  methods: {
    updateInfoCompensation: function (data) {
      this.infoCashOrder.methode_get = data.methode_get
      this.infoCashOrder.compensation_option = data.compensation_option
      this.infoCashOrder.amount_cash = data.amount_cash
      this.step = data.step
    },
    CheckMonetaryOrder: function () {
      let self = this
      let monetary = _.find(self.MonetaryService.list_monetary, { id: parseInt(self.monetaryId) })
      self.infoCashOrder = _.find(monetary.orders, { id: parseInt(self.orderId) })
      if (self.infoCashOrder.status == 0) {
        let data = {
          monetary_order_id: self.orderId,
          status: 1
        }
        self.$store.dispatch('MonetaryCompensation/openMonetaryCompensationOrder', data).then(function (res) {
          if (res.success == true) {
            _.each(monetary.orders, function (e) {
              if (e.id == self.orderId) {
                e.status = 1
              }
            })
            self.$store.dispatch('Home/updateMonetary', self.MonetaryService)
          }
        })
      }

      if (self.infoCashOrder.compensation_type == '1') {
        self.$router.push({ path: '/cash-pickup', query: { secret: self.secret, order_id: self.orderId } })
      } else if (self.infoCashOrder.compensation_type == '3') {
        self.$router.push({
          path: '/monetary-compensation',
          query: { secret: self.secret, monetary_id: self.monetaryId, order_id: self.orderId }
        })
      }
    },
    processConfirm: function (data) {
      let self = this
      let monetary = _.find(self.MonetaryService.list_monetary, { id: parseInt(self.monetaryId) })
      if (data == 1) {
        self.step = data
      } else {
        let open_amount_order = 0
        if (self.infoCashOrder.open_amount > 0) {
          open_amount_order = self.infoCashOrder.open_amount - self.infoCashOrder.amount_cash
        } else {
          open_amount_order = self.infoCashOrder.compensation_amount - self.infoCashOrder.amount_cash
        }
        let dataSend = {
          secret: self.secret,
          cur_pax_id: this.pax.curPaxID ? this.pax.curPaxID : this.pax.id,
          monetary_order_id: self.orderId,
          type: self.infoCashOrder.methode_get,
          option: self.infoCashOrder.compensation_option,
          amount: self.infoCashOrder.amount_cash,
          open_amount: open_amount_order
        }
        self.$store.dispatch('MonetaryCompensation/confirmMonetary', dataSend).then(function (response) {
          if (response.success == true) {
            let resData = response.data
            _.each(monetary.orders, function (e) {
              if (e.id == self.orderId) {
                e.status = resData.status
                e.open_amount = resData.open_amount
                e.security_code = resData.security_code
                e.amount = resData.amount
                e.compensation_type = resData.monetary.compensation_type
                e.compensation_option = resData.monetary.compensation_option
                e.expiry_date = resData.expiry_date
                e.number_order = resData.number_order
              }
            })
            self.$store.dispatch('Home/updateMonetary', self.MonetaryService)
            self.infoCashOrder = _.first(
              _.filter(monetary.orders, function (order) {
                return order.id == self.orderId
              })
            )

            if (resData.compensation_type == 1) {
              self.$router.push({ path: '/cash-pickup', query: { secret: self.secret, order_id: self.orderId } })
            } else if (resData.compensation_type == 3) {
              self.$router.push({
                path: '/monetary-compensation',
                query: { secret: self.secret, monetary_id: self.monetaryId, order_id: self.orderId }
              })
            }
          } else {
            let message = !_.isEmpty(response.message) ? response.message : 'Failed!'
            self.$swal(message)
          }
        })
      }
    }
  }
}
</script>
